import React,{useState, useEffect} from 'react';
import axios from 'axios';
import {OverlayTrigger,Popover,Spinner} from 'react-bootstrap';

const ProductInfo = ({productData,asin,cst}) => {
    const [productDataI,setProductData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!asin || asin === "No ASIN") {
            setLoading(false);
            return;
        }

        const fetchProductData = async () => {
            setLoading(true);
            setError(null);
            setProductData(null);
            try {
                const options = {
                    method: 'GET',
                    url: 'https://real-time-amazon-data.p.rapidapi.com/product-details',
                    params: {
                        asin: asin,
                        country: 'US' 
                    },
                    headers: {
                        'X-RapidAPI-Key': '84df21333fmsh74459cace4d233cp17f230jsn44980d697427', 
                        'X-RapidAPI-Host': 'real-time-amazon-data.p.rapidapi.com'
                    }
                };

                const response = await axios.request(options);
                if (response.data && response.data.status === 'OK') {
                    setProductData(response.data.data);
                } else {
                   setError('No se pudieron obtener los datos del producto.');
                }
            } catch (err) {
                console.error("Error fetching product data:", err);
                setError('Error loading product.');
            } finally {
                setLoading(false);
            }
        };

        fetchProductData();
    }, [asin]);
    if (!asin || asin === "No ASIN") {
        return <span className="cst-text text-center mx-2">{cst}</span>;
    }
     if (loading) {
        return <Spinner animation="border" size="sm" />;
    }
    if (!productDataI||productData===undefined) {
        return <Spinner animation="border" size="sm" />;
    }
    if (error || !productData) {
        return <span>{asin || 'No ASIN'}</span>;
    }
    if (productData === null || productData.error) {
        return <span title={`No information found for ${asin}`}>- No info found -</span>;
    }
    const truncateTitle = (text, maxLength = 20) => {
        if (!text) return '';
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength).trim() + '...';
    };

    const popover = (
        <Popover id={`popover-${asin}`} style={{ maxWidth: '350px', zIndex: 9999 }}>
            <Popover.Body>
                <div className="d-flex">
                    <img src={productData.product_photo} alt={productData.product_title} style={{ width: '100px', height: '100px', objectFit: 'contain', marginRight: '15px' }} />
                    <div>
                        <h6>{productData.product_title}</h6>
                        <p className="mb-1"><strong>ASIN:</strong> {productData.asin}</p>
                        <p className="mb-1"><strong>Rating:</strong> {productData.product_star_rating} ⭐ ({productData.product_num_ratings} reviews)</p>
                        <p className="mb-0"><strong>Price:</strong> {productData.product_price}</p>
                    </div>
                </div>
                 <div className="d-flex justify-content-around mt-3">
                    <a href={productData.product_url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-secondary">
                        View on Amazon
                    </a>
                    <button className="btn btn-sm btn-light" onClick={() => navigator.clipboard.writeText(asin)}>
                        Copy ASIN
                    </button>
                </div>
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger placement="right" delay={{ show: 600, hide: 800 }} overlay={popover}>
            <div className="d-flex align-items-center">
                <img src={productData.product_photo} alt={productData.product_title} style={{ width: '40px', height: '40px', objectFit: 'contain', marginRight: '10px' }} />
                <div>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }} title={productData.product_title}>
                        {truncateTitle(productData.product_title, 20)}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>{productData.asin}</div>
                </div>
            </div>
        </OverlayTrigger>
    );
};

export default ProductInfo;
